import React from "react";
import themePropTypes from "../theme-prop-types";

const Switch = ({ checked, labelText, onChange, identifier }) => (
  /* eslint-disable jsx-a11y/label-has-associated-control */
  <label
    className='switch-container-web-sdk'
    data-testid={`switch-${identifier}`}
    htmlFor={identifier}
  >
    <span
      role='switch'
      aria-checked={checked}
      className='switch-control-web-sdk'
      tabIndex='0'
      onKeyDown={event => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onChange(event);
        }
      }}
    >
      <input
        defaultChecked={checked}
        onChange={onChange}
        className={`switch-checkbox-web-sdk${checked ? " checked" : ""}`}
        data-testid={`checkbox-${identifier}`}
        id={identifier}
        type='checkbox'
      />
      <span
        className={`switch-label-web-sdk ${
          checked ? "switch-checked-web-sdk" : ""
        }`}
      >
        <span className='switch-button-web-sdk' />
      </span>
    </span>
    <span className='switch-label-text-web-sdk'>{labelText}</span>
  </label>
);
Switch.propTypes = themePropTypes.switchControl;

export default Switch;
